import { loadStripe } from "@stripe/stripe-js";

class StripeCheckout {
constructor() {
    this.stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_API_KEY);
    this.productId = "prod_SBJJFYaS080sK7";
    this.priceIds = {
      ForIndividual: "price_1RGwn1RsoIc9PRwXfsJMQ4bl",
      CareerAdvancementCourses : "price_1RGwh2RsoIc9PRwXo0TBojmm",
      ProfessionalGrowthCourses : "price_1RGwkjRsoIc9PRwX54v54WT1",
      BiteSizedCourses : "price_1RGwn1RsoIc9PRwXfsJMQ4bl",
    };
    this.priceIdsINR = {
    ForIndividual: "price_1RGwnpRsoIc9PRwX8sB2MJyX", 
    CareerAdvancementCourses: "price_1RGwjSRsoIc9PRwXCkZjIOiB", 
    ProfessionalGrowthCourses: "price_1RGwlPRsoIc9PRwXuOcKtnV1", 
    BiteSizedCourses: "price_1RGwnpRsoIc9PRwX8sB2MJyX", 
  };
  this.academyTitleToPriceId = {
    "Product Management Foundations": {
      USD: "price_1RGwltRsoIc9PRwXmD7GQ43m",
      INR: "price_1RGwmdRsoIc9PRwXvYGejfp6"
    },
    "UX Foundations": {
      USD: "price_1RGwltRsoIc9PRwXmD7GQ43m", 
      INR: "price_1RGwmdRsoIc9PRwXvYGejfp6"
    },
    "UI Foundations": {
      USD: "price_1RGwltRsoIc9PRwXmD7GQ43m",
      INR: "price_1RGwmdRsoIc9PRwXvYGejfp6"
    },
    "Service Design Foundations": {
      USD: "price_1RGwltRsoIc9PRwXmD7GQ43m",
      INR: "price_1RGwmdRsoIc9PRwXvYGejfp6"
    },
    "Digital Marketing Foundations": {
      USD: "price_1RGwltRsoIc9PRwXmD7GQ43m",
      INR: "price_1RGwmdRsoIc9PRwXvYGejfp6"
    }
  };
  this.currentCurrency = "USD"; 
}
async getUserLocation() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const locationData = await response.json();
    return {
      country: locationData.country_name,
      countryCode: locationData.country_code
    };
  } catch (error) {
    console.error('Error detecting location:', error);
    return { country: null, countryCode: null }; 
  }
}

async setPricingByLocation() {
  try {
    const location = await this.getUserLocation();
    
    if (location.countryCode === "IN") {
      this.currentCurrency = "INR";
      console.log("Location detected as India. Using INR pricing.");
    } else {
      this.currentCurrency = "USD";
      console.log(`Location detected as ${location.country || 'Unknown'}. Using USD pricing.`);
    }
  } catch (error) {
    console.error("Error setting pricing by location:", error);
    this.currentCurrency = "USD"; 
  }
  
  return this.currentCurrency;
}


getPriceId(courseType = "default", academyTitle = null) {

  if (courseType === "ProfessionalGrowthCourses" && academyTitle && 
      this.academyTitleToPriceId[academyTitle]) {
    
 
    const currencyKey = this.currentCurrency === "INR" ? "INR" : "USD";
    return this.academyTitleToPriceId[academyTitle][currencyKey];
  }
  
  if (this.currentCurrency === "INR") {
    return this.priceIdsINR[courseType] || this.priceIdsINR.default;
  }
  return this.priceIds[courseType] || this.priceIds.default;
}

async createCheckoutSession(customerData, courseType = "default") {
  try {

    await this.setPricingByLocation();
    const priceId = this.getPriceId(courseType, customerData.academyTitle);
    
    console.log(`Creating checkout with ${this.currentCurrency} pricing (${priceId})`);
    
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/create-checkout-session`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: this.productId,
          priceId: priceId,
          customerEmail: customerData.businessemail,
          customerName: `${customerData.firstname} ${customerData.lastname}`,
          metadata: {
            academyTitle: customerData.academyTitle,
            companyName: customerData.companyName,
            jobTitle: customerData.jobtitle,
            phoneNumber: customerData.phoneNumber,
            utmSource: customerData.utmSource,
            utmMedium: customerData.utmMedium,
            utmCampaign: customerData.utmCampaign,
            utmContent: customerData.utmContent,
            utmTerm: customerData.utmTerm,
            utmId: customerData.utmId,
            courseType: courseType,
            currency: this.currentCurrency, 
            detectedCountry: customerData.detectedCountry || "auto-detected"
          },
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message || "Failed to create checkout session"
      );
    }

    const session = await response.json();

    const stripe = await this.stripePromise;
    const { error } = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (error) {
      console.error("Stripe checkout error:", error);
      throw new Error(error.message);
    }
  } catch (error) {
    console.error("Error creating checkout session:", error);
    throw error;
  }
}
}
export default new StripeCheckout();

